import gql from 'graphql-tag';
import createQuery from './createQuery';

export default createQuery(gql`
  query getBasicAuthKey($token: String!, $key: String!) {
    getBasicAuthKey(token: $token, key: $key) {
      data,
    }
  }
`);
